class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.button = null;
    }
  
    connectedCallback() {
      this.button = this.querySelector("button") || document.createElement("button");
      if (!this.contains(this.button)) {
        this.button.textContent = "↑";
        this.appendChild(this.button);
      }
  
      window.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
          this.button.style.display = "block";
        } else {
          this.button.style.display = "none";
        }
      });
  
      this.button.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  }
  
  customElements.define("back-to-top", BackToTop);
  